// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionCard_institution-card__NR9mV {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.InstitutionCard_institution-card__NR9mV div:empty {
  display: none;
}
.InstitutionCard_institution-card__top__Dfedg {
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
}
.InstitutionCard_institution-card__body__xslZr {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.InstitutionCard_institution-card__body--item__yMBlz {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.InstitutionCard_institution-card__body--item--title__x\\+Pj\\+ {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.InstitutionCard_institution-card__body--item--value__5szNI {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  align-self: stretch;
  color: var(--grey-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.InstitutionCard_institution-card__body__left__TU2eo {
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0;
}
.InstitutionCard_institution-card__body__right__eub1V {
  max-width: 500px;
  width: 100%;
  min-height: 100%;
  padding-left: 16px;
  border-left: 1px solid var(--accent-color-medium);
}
.InstitutionCard_institution-card__bottom__5QRI0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_link__-CIrk {
  cursor: pointer;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_link__-CIrk:hover {
  text-decoration: underline;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_avatar__dZoNx {
  width: 128px;
  aspect-ratio: 16/9;
  border-radius: 4px;
  object-fit: contain;
  border: 1px solid var(--light-grey);
  padding: 4px;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_name__wxSlm {
  color: var(--explore-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 100% */
  letter-spacing: 0.4px;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_name--wrapper__AwuEc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_entity-actions__mHqDZ {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_entity-actions__mHqDZ .MuiButton-root {
  box-sizing: border-box;
  min-width: 130px;
  min-height: 36px;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_favorite-btn__nCpj9 {
  display: none;
  text-transform: uppercase;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_statistics__hIWlQ .InstitutionCard_statistic__V-mpk {
  display: flex;
  align-items: center;
  gap: 4px;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_statistics__hIWlQ .InstitutionCard_statistic__V-mpk svg {
  min-width: 24px;
  height: 24px;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_statistics__hIWlQ .InstitutionCard_statistic__V-mpk svg path {
  stroke: var(--accent-color-medium);
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_keywords__zph9M {
  max-height: 76px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_keywords__zph9M span {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_keywords__zph9M .InstitutionCard_keywords--item__bYBdM {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  border-radius: 20px;
  background: var(--accent-color-light);
  color: var(--text-1);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-shadow: none;
  text-transform: initial;
}
.InstitutionCard_institution-card__NR9mV .InstitutionCard_bio-institution__uwo0S {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  align-self: stretch;
  overflow: hidden;
  color: var(--grey-text);
  text-overflow: ellipsis;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media only screen and (max-width: 480px) {
  .InstitutionCard_institution-card__NR9mV .InstitutionCard_avatar__dZoNx {
    width: 40px;
  }
  .InstitutionCard_institution-card__NR9mV .InstitutionCard_name__wxSlm {
    font-size: 16px;
    font-weight: 500;
  }
  .InstitutionCard_institution-card__NR9mV .InstitutionCard_keywords__zph9M span:first-child {
    display: none;
  }
  .InstitutionCard_institution-card__NR9mV .InstitutionCard_institution-card__body__xslZr {
    flex-direction: column;
    gap: 8px;
  }
  .InstitutionCard_institution-card__NR9mV .InstitutionCard_institution-card__body__right__eub1V {
    max-width: initial;
    padding-left: 0;
    border-left: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/InstitutionCard/InstitutionCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACF;AAEI;EACE,aAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAHN;AAKM;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKM;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAMI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;AAJN;AAOI;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;AALN;AASE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AAUE;EACE,eAAA;AARJ;AASI;EACE,0BAAA;AAPN;AAWE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AATJ;AAYE;EACE,2BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,qBAAA;AAVJ;AAWI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AATN;AAaE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAXJ;AAaI;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAXN;AAeE;EACE,aAAA;EACA,yBAAA;AAbJ;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfN;AAiBM;EACE,eAAA;EACA,YAAA;AAfR;AAiBQ;EACE,kCAAA;AAfV;AAqBE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnBN;AAuBM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArBR;AA0BE;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxBJ;;AA4BA;EAEI;IACE,WAAA;EA1BJ;EA6BE;IACE,eAAA;IACA,gBAAA;EA3BJ;EA8BI;IACE,aAAA;EA5BN;EAiCI;IACE,sBAAA;IACA,QAAA;EA/BN;EAiCM;IACE,kBAAA;IACA,eAAA;IACA,iBAAA;EA/BR;AACF","sourcesContent":[".institution-card {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n\n  div {\n    &:empty {\n      display: none;\n    }\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  &__body {\n    display: flex;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-self: stretch;\n\n    &--item {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 4px;\n      align-self: stretch;\n\n      &--title {\n        color: var(--grey-text);\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n      &--value {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n        align-self: stretch;\n        color: var(--grey-text);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n    &__left {\n      display: flex;\n      padding-right: 16px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      flex: 1 0 0;\n    }\n\n    &__right {\n      max-width: 500px;\n      width: 100%;\n      min-height: 100%;\n      padding-left: 16px;\n      border-left: 1px solid var(--accent-color-medium);\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  .link {\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .avatar {\n    width: 128px;\n    aspect-ratio: 16/9;\n    border-radius: 4px;\n    object-fit: contain;\n    border: 1px solid var(--light-grey);\n    padding: 4px;\n  }\n\n  .name {\n    color: var(--explore-color);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 100% */\n    letter-spacing: 0.4px;\n    &--wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n    }\n  }\n\n  .entity-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n\n    :global(.MuiButton-root) {\n      box-sizing: border-box;\n      min-width: 130px;\n      min-height: 36px;\n    }\n  }\n\n  .favorite-btn {\n    display: none;\n    text-transform: uppercase;\n  }\n\n  .statistics {\n    .statistic {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      svg {\n        min-width: 24px;\n        height: 24px;\n\n        path {\n          stroke: var(--accent-color-medium);\n        }\n      }\n    }\n  }\n\n  .keywords {\n    max-height: 76px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    span {\n      color: var(--grey-text);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .keywords {\n      &--item {\n        display: flex;\n        padding: 6px 12px;\n        align-items: center;\n        border-radius: 20px;\n        background: var(--accent-color-light);\n        color: var(--text-1);\n        text-align: center;\n        font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n        font-size: 0.85rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        box-shadow: none;\n        text-transform: initial;\n      }\n    }\n  }\n\n  .bio-institution {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 4;\n    align-self: stretch;\n    overflow: hidden;\n    color: var(--grey-text);\n    text-overflow: ellipsis;\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .institution-card {\n    .avatar {\n      width: 40px;\n    }\n\n    .name {\n      font-size: 16px;\n      font-weight: 500;\n    }\n    .keywords {\n      span:first-child {\n        display: none;\n      }\n    }\n\n    .institution-card {\n      &__body {\n        flex-direction: column;\n        gap: 8px;\n\n        &__right {\n          max-width: initial;\n          padding-left: 0;\n          border-left: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-card": `InstitutionCard_institution-card__NR9mV`,
	"institution-card__top": `InstitutionCard_institution-card__top__Dfedg`,
	"institution-card__body": `InstitutionCard_institution-card__body__xslZr`,
	"institution-card__body--item": `InstitutionCard_institution-card__body--item__yMBlz`,
	"institution-card__body--item--title": `InstitutionCard_institution-card__body--item--title__x+Pj+`,
	"institution-card__body--item--value": `InstitutionCard_institution-card__body--item--value__5szNI`,
	"institution-card__body__left": `InstitutionCard_institution-card__body__left__TU2eo`,
	"institution-card__body__right": `InstitutionCard_institution-card__body__right__eub1V`,
	"institution-card__bottom": `InstitutionCard_institution-card__bottom__5QRI0`,
	"link": `InstitutionCard_link__-CIrk`,
	"avatar": `InstitutionCard_avatar__dZoNx`,
	"name": `InstitutionCard_name__wxSlm`,
	"name--wrapper": `InstitutionCard_name--wrapper__AwuEc`,
	"entity-actions": `InstitutionCard_entity-actions__mHqDZ`,
	"favorite-btn": `InstitutionCard_favorite-btn__nCpj9`,
	"statistics": `InstitutionCard_statistics__hIWlQ`,
	"statistic": `InstitutionCard_statistic__V-mpk`,
	"keywords": `InstitutionCard_keywords__zph9M`,
	"keywords--item": `InstitutionCard_keywords--item__bYBdM`,
	"bio-institution": `InstitutionCard_bio-institution__uwo0S`
};
export default ___CSS_LOADER_EXPORT___;
